import { render, staticRenderFns } from "./PolicyCancelSuccessDialog.vue?vue&type=template&id=2901fa3c&scoped=true&"
import script from "./PolicyCancelSuccessDialog.vue?vue&type=script&lang=js&"
export * from "./PolicyCancelSuccessDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2901fa3c",
  null
  
)

export default component.exports